module.exports = __webpack_public_path__ + "img/selected4-min.81aa0df1.png";